import * as React from 'react'
import clsx from 'clsx'

import styles from './Container.module.css'

export type ContainerProps = {
  children: React.ReactNode
  className?: string
}

/** Centered page container (max-width + horizontal padding). */
export function Container({ children, className }: ContainerProps): React.ReactElement {
  return <div className={clsx(styles.wrap, className)}>{children}</div>
}
